import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Compass } from "@phosphor-icons/react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/f7842974-09b3-4b3e-bebd-5a0c602980d0/images/4041816de2b74380f38dffc005e0fad56727727ddfc7d1d3f4ca5400a6cceaad.png";

export const Hero = () => {
  return (
    <section
      id="top"
      className="relative min-h-screen w-full overflow-hidden bg-vynex-navy"
      data-testid="hero-section"
    >
      {/* Cinematic background */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Cargo ship at port during blue hour"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-overlay" />
        <div className="absolute inset-0 bg-gradient-to-t from-vynex-navy via-transparent to-transparent" />
      </div>

      <div className="absolute left-6 lg:left-8 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-vynex-gold/40 to-transparent z-10" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-44 pb-24 lg:pt-52 lg:pb-32 min-h-screen flex flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex items-center gap-3 mb-10"
        >
          <span className="h-px w-12 bg-vynex-gold" />
          <span
            className="eyebrow text-vynex-gold"
            data-testid="hero-eyebrow"
          >
            Global Commodities Trading House
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.35 }}
          className="font-display text-white text-5xl md:text-6xl lg:text-[88px] leading-[1.02] tracking-tight max-w-5xl"
          data-testid="hero-headline"
        >
          Connecting Markets.
          <br />
          <span className="italic font-normal text-vynex-silver">
            Delivering Value.
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.55 }}
          className="mt-8 max-w-2xl text-vynex-silver/80 text-base md:text-lg leading-relaxed"
          data-testid="hero-subheadline"
        >
          Singapore-based commodities trading company focused on metals
          sourcing, trade coordination, and long-term supply partnerships.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.75 }}
          className="mt-12 flex flex-col sm:flex-row gap-4"
        >
          <a
            href="#commodities"
            className="group inline-flex items-center gap-3 bg-vynex-gold text-vynex-navy px-8 py-4 text-[11px] tracking-[0.25em] uppercase font-medium hover:bg-vynex-gold-light transition-colors"
            data-testid="hero-cta-explore"
          >
            <Compass size={15} weight="bold" />
            Explore Markets
            <ArrowRight
              size={14}
              weight="bold"
              className="transition-transform group-hover:translate-x-1"
            />
          </a>
          <a
            href="#contact"
            className="group inline-flex items-center gap-3 border border-vynex-silver/40 text-white px-8 py-4 text-[11px] tracking-[0.25em] uppercase font-medium hover:border-vynex-gold hover:text-vynex-gold transition-all"
            data-testid="hero-cta-contact"
          >
            Contact Us
            <ArrowRight
              size={14}
              weight="bold"
              className="transition-transform group-hover:translate-x-1"
            />
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1 }}
          className="mt-24 flex flex-wrap items-center gap-x-10 gap-y-3 max-w-4xl border-t border-white/10 pt-8 eyebrow text-vynex-silver/60"
        >
          <span data-testid="credential-hq">Singapore HQ</span>
          <span className="w-1 h-1 bg-vynex-gold rounded-full" />
          <span>Metals &amp; Sourcing</span>
          <span className="w-1 h-1 bg-vynex-gold rounded-full" />
          <span>Cross-Border Trade</span>
          <span className="w-1 h-1 bg-vynex-gold rounded-full" />
          <span>Disciplined Execution</span>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
